import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class ScreenSizeService {
  private readonly LOW_RESOLUTION_DEVICES = [" TV ", " A30"];

  /**
   * Detects if the current device has a low resolution screen.
   * This method focuses on landscape-oriented displays like TVs and POS devices,
   * ignoring typical mobile/tablet form factors.
   *
   * @returns {boolean} True if device is identified as low resolution screen device
   */
  isLowResolutionScreen(): boolean {
    return this.isLowResolutionScreenDevice(navigator.userAgent);
  }

  private isLowResolutionScreenDevice(userAgent: string): boolean {
    if (!userAgent) {
      return false;
    }

    const match = userAgent.match(/Android\s(.+?)\sBuild/);

    if (!match || !match[1]) {
      return false;
    }

    return this.LOW_RESOLUTION_DEVICES.some((device) => match[1].includes(device));
  }
}
